import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from '../../../../components';
import { CheckCircle } from '@phosphor-icons/react';

const Step_41 = ({
  error,
  setError,
}) => {

  const { userData } = useSelector((state) => state.app);
  const { userContactData } = useSelector((state) => state.sellTickets);
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const data = {};
    if (userData?.email) data.email = userData.email;
    if (userData?.whatsappNumber && !userContactData?.phone) data.phone = userData.whatsappNumber?.toString();
    if (userData?.name && !userContactData?.name) data.name = userData.name;

    dispatch({ type: 'SELL_TICKET:USER_CONTACT:SET', data: { ...userContactData, ...data } })
  }, [userData]);

  const onChange = (key, val) => dispatch({ type: 'SELL_TICKET:USER_CONTACT:SET', data: { ...userContactData, [key]: val } });

  const validateName = (name) => {
    if (!name) {
      setError((prev) => ({ ...prev, name: 'Name cannot be empty.' }));
    } else if (!/^[A-Z][a-z]*(?: [A-Z][a-z]*)*$/.test(name)) {
      setError((prev) => ({ ...prev, name: 'Name must be in Pascal case.' }));
    } else {
      setError((prev) => ({ ...prev, name: '' }));
    }
  };

  const validateEmail = (email) => {
    if (!email) {
      setError((prev) => ({ ...prev, email: 'Email cannot be empty.' }));
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setError((prev) => ({ ...prev, email: 'Invalid email format.' }));
    } else {
      setError((prev) => ({ ...prev, email: '' }));
    }
  };

  const validatePhone = (phone) => {
    if (!phone) {
      setError((prev) => ({ ...prev, phone: 'Phone number cannot be empty.' }));
    } else if (!/^\d{10}$/.test(phone)) {
      setError((prev) => ({ ...prev, phone: 'Phone number must be 10 digits.' }));
    } else {
      setError((prev) => ({ ...prev, phone: '' }));
    }
  };

  const handleNameChange = (e) => {
    const pascalCaseName = e.target.value.replace(/\b\w/g, char => char.toUpperCase());
    onChange('name', pascalCaseName);
    validateName(pascalCaseName);
  };

  const handleEmailChange = (e) => {
    onChange('email', e.target.value);
    validateEmail(e.target.value);
  };

  const handlePhoneChange = (e) => {
    onChange('phone', e.target.value);
    validatePhone(e.target.value);
  };

  return (
    <div className='flex flex-col gap-6 py-7'>
      <div className='heading-36'>Add your details</div>
      <Input
        label='Name'
        placeHolder=''
        value={userContactData?.name}
        onChange={handleNameChange}
        validationStatus={error.name ? 'error' : ''}
        helpText={error.name || ''}
        width='100%'
      />
      <div className='flex items-center relative'>
        <Input
          label='Email'
          placeHolder=''
          value={userContactData?.email}
          disabled={true}
          onChange={handleEmailChange}
          validationStatus={error.email ? 'error' : 'default'}
          helpText={error.email || ''}
          width='100%'
        />
        {userContactData?.email &&
          <CheckCircle
            size={24}
            color={'#009D64'}
            weight={'fill'}
            className="absolute right-8 top-14 transform -translate-y-1/2"
          />}
      </div>
      <Input
        label='Whatsapp number'
        placeHolder=''
        value={userContactData?.phone}
        onChange={handlePhoneChange}
        contentLeft={<>+91</>}
        validationStatus={error.phone ? 'error' : ''}
        helpText={error.phone || ''}
        type='number'
        autoFocus
        required
        width='100%'
      />
    </div>
  );
};


export default Step_41;
